import { render, staticRenderFns } from "./SliderNav.vue?vue&type=template&id=cbd0d00c&"
import script from "./SliderNav.vue?vue&type=script&lang=js&"
export * from "./SliderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports